import type { AuthLoginResponse } from "@chat-yai/shared";
import { request } from "@/api/client";

export const authApi = {
  register(input: { email: string; password: string }) {
    return request<{ ok: true }>("/auth/register", {
      method: "POST",
      body: input,
      skipAuth: true,
    });
  },
  login(input: { email: string; password: string }) {
    return request<AuthLoginResponse>("/auth/login", {
      method: "POST",
      body: input,
      skipAuth: true,
    });
  },
  logout() {
    return request<{ ok: true }>("/auth/logout", { method: "POST" });
  },
  refresh() {
    return request<AuthLoginResponse>("/auth/refresh", {
      method: "POST",
      skipAuth: true,
    });
  },
  verifyEmail(input: { token: string }) {
    return request<{ ok: true }>("/auth/verify-email", {
      method: "POST",
      body: input,
      skipAuth: true,
    });
  },
  forgotPassword(input: { email: string }) {
    return request<{ ok: true }>("/auth/forgot-password", {
      method: "POST",
      body: input,
      skipAuth: true,
    });
  },
  resetPassword(input: { token: string; new_password: string }) {
    return request<{ ok: true }>("/auth/reset-password", {
      method: "POST",
      body: input,
      skipAuth: true,
    });
  },
};
